import createDataContext from './createDataContext';
import { fetchVideoViews as getVideoViews, postVideoView } from '../requests';

const INTRO_VIDEO =
  'https://d1r6ad2l0u3q6g.cloudfront.net/f74e1ddf-0b6b-479b-89e0-21f152c9b602/hls/EV IPS World Video V4.m3u8';
const INTRO_VIDEO_NAME = 'IPS_INTRO_VIDEO_1';
const initState = {
  isFetching: true,
  videoViews: [],
  showPopupVideo: false,
  source: INTRO_VIDEO,
  videoName: INTRO_VIDEO_NAME,
};

function videoReducer(state, action) {
  switch (action.type) {
    case 'fetchingVideoViews':
      return { ...state, isFetching: true };
    case 'clearVideoViews':
      return { ...state, videoViews: action.payload };
    case 'fetchedVideoViews':
      return { ...state, isFetching: false, videoViews: action.payload };
    case 'showPopupVideo':
      return { ...state, showPopupVideo: true };
    case 'hidePopupVideo':
      return { ...state, showPopupVideo: false };
    default:
      return state;
  }
}

function setPopupVideo(dispatch) {
  return function (isShow) {
    dispatch({ type: isShow ? 'showPopupVideo' : 'hidePopupVideo' });
  };
}

function fetchVideoViews(dispatch) {
  return async function () {
    try {
      dispatch({ type: 'fetchingVideoViews' });
      dispatch({ type: 'clearVideoViews' });
      const views = await getVideoViews();
      dispatch({ type: 'fetchedVideoViews', payload: views });
      if (!views.find((v) => v.videoName === INTRO_VIDEO_NAME))
        dispatch({ type: 'showPopupVideo' });
    } catch (error) {}
  };
}

function createVideoView(dispatch) {
  return async function () {
    try {
      await postVideoView(INTRO_VIDEO_NAME);
      await fetchVideoViews(dispatch)();
    } catch (error) {}
  };
}

function createVideoViewIfNone(dispatch) {
  return async function () {
    try {
      await postVideoView(INTRO_VIDEO_NAME);
      await fetchVideoViews(dispatch)();
    } catch (error) {}
  };
}

export const { Context, Provider } = createDataContext(
  videoReducer,
  {
    setPopupVideo,
    fetchVideoViews,
    createVideoView,
  },
  initState
);
